module.exports = __webpack_public_path__ + "img/TagsUploadExampleEngXLSX.193569aa.png";